<template>
  <v-container style="overflow-y: auto; overflow-x: hidden; height: 80vh">
    <div>
      <Formulary v-if="invoice" :key="refreshAmount" ref="formulary" :invoice="invoice" style="margin-top: 15px" @refresh="refresh()" @error="refresh" />
      <v-row style="justify-content: center;margin-top: 10px">
        <v-icon class="mr-2">
          mdi-book-lock
        </v-icon>
        {{ $t('InvoiceInformation.BlockChain') }}
      </v-row>
      <div v-if="blockchain">
        <v-row>
          <v-col>
            <v-text-field v-model="blockchain.link" style="margin-top: 15px" :label="$t('InvoiceInformation.Link to Blockchain')" readonly filled rounded dense prepend-inner-icon="mdi-link-variant" />
            <v-text-field v-model="blockchain.amount" :label="$t('InvoiceInformation.Blockchain Amount')" readonly filled rounded dense prepend-inner-icon="mdi-cash" />
            <v-text-field v-model="blockchain.date" style="margin-top: 15px" :label="$t('InvoiceInformation.Blockchain Date')" readonly filled rounded dense prepend-inner-icon="mdi-timetable" />
            <v-text-field v-model="blockchain.status" :label="$t('InvoiceInformation.Blockchain Status')" readonly filled rounded dense prepend-inner-icon="" />
          </v-col>
        </v-row>
        <v-row>
          <v-btn rounded class="btn-primary" x-large style="margin-right: auto; margin-left: auto" dark @click="addLink()">
            {{ $t('InvoiceInformation.See transaction') }}
          </v-btn>
        </v-row>
      </div>
      <div v-else>
        <v-alert dense type="primary" style="margin-top: 15px" outlined>
          {{ $t('InvoiceInformation.There is no data for this invoice stored on the Blockchain.') }}
        </v-alert>
      </div>
    </div>
  </v-container>
</template>

<script>
import Constants from "../../constants";
import Formulary from "./invoice/Formulary";
import ApiRepository from "../repositories/ApiRepository";
import moment from "moment";

export default {
    name: "InvoiceInformation",
    components: {Formulary},
    props: {invoiceId: {type: String, default: null},
    },
    data () {
        return {
            tab: null,
            loading: true,
            refreshAmount: 0,
            invoice: null,
            refreshing: false,
            blockchain: {
                link: null,
                date: null,
                status: null,
                amount: null,
            },
            itemsTabs: [
                this.$t('InvoiceInformation.Basic Information'), this.$t('InvoiceInformation.Blockchain Information'),
            ],
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        async fetch () {
            this.$data.loading = true;
            await ApiRepository.getInvoiceById(this.invoiceId)
                .then((res) => {
                    if (res.data.invoice) {
                        this.invoice = res.data.invoice;
                        if (!this.refreshing && res.data.invoice.hash) {
                            this.blockchain.link = Constants.BLOCKCHAIN_URL + res.data.invoice.hash;
                            ApiRepository.getInvoiceSC(res.data.invoice._id)
                                .then(res => {
                                    this.blockchain.amount = res.data.amount + " " + "€";
                                    this.blockchain.status = res.data.status;
                                    switch (this.blockchain.status) {
                                    case Constants.INVOICE.STATUS_CREATED:
                                        this.blockchain.status = this.$t('InvoiceStatus.created');
                                        break;
                                    case Constants.INVOICE.STATUS_COMPENSATED:
                                        this.blockchain.status = this.$t('InvoiceStatus.Compensated');
                                        break;
                                    case Constants.INVOICE.STATUS_PAYED:
                                        this.blockchain.status  = this.$t('InvoiceStatus.Payed');
                                        break;
                                    case Constants.INVOICE.STATUS_PENDING:
                                        this.blockchain.status = this.$t('InvoiceStatus.Pending');
                                        break;
                                    case Constants.INVOICE.STATUS_TEMPORARY:
                                        this.blockchain.status = this.$t('InvoiceStatus.Temporary');
                                        break;
                                    default:
                                        this.blockchain.status = this.$t('InvoiceStatus.Unknown');
                                        break;
                                    }
                                    this.blockchain.date = moment(res.data.date).format("DD-MM-YYYY ");
                                })
                                .catch((err) => {
                                    console.log(this.$t("InvoiceStatus.ERROR: Cannot get blockChain data") + err);
                                });
                        }
                    }
                })
                .finally(() => {
                    this.$data.loading = false;
                });
        },
        payInvoice () {
            ApiRepository.invoicePayed(this.invoice._id)
                .then(response => {
                    if (response.data) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Invoice payed successfully!')});
                        this.invoice.status = Constants.INVOICE.STATUS_PAYED;
                    }
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error paying invoice'), color: "error"});
                });
        },
        async refresh () {
            this.refreshing = true;
            await this.fetch();
            this.refreshAmount += 1;
        },
        addLink () {
            window.open(this.blockchain.link);
        }
    },
};
</script>

<style scoped>
</style>
